import React from "react";
import { contact } from "../mock";

export default function Footer() {
  return (
    <footer className="border-t bg-white">
      <div className="mx-auto max-w-6xl px-4 py-8 text-sm text-slate-600 flex flex-col md:flex-row items-center justify-between gap-3">
        <div>
          © {new Date().getFullYear()} Rahul Uchit. All rights reserved.
        </div>
        <div className="flex items-center gap-4">
          <a className="hover:text-slate-900" href={`mailto:${contact.email}`}>{contact.email}</a>
          <a className="hover:text-slate-900" href={contact.linkedin} target="_blank" rel="noreferrer">LinkedIn</a>
        </div>
      </div>
    </footer>
  );
}